"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AddFamilyMemberToMembershipDto = exports.MembershipMemberImportResponseDto = exports.MembershipMemberDto = exports.MembershipImportResponseDto = exports.DateAndUserIdsDto = exports.SimpleMembershipDto = exports.GetMembershipDataQueryDto = exports.CancelMembershipDto = exports.FindMembersOptionsDto = exports.MemberIdDto = exports.MembershipIdsDto = exports.SetMembersStartDateByOrganization = exports.FindMembershipsByUserIdDto = exports.FindMembershipByFiltersDto = exports.FindMembershipsByOrganizationIdDto = exports.FindMembershipByIdDto = exports.UpdateMembershipMediaDto = exports.UpdateMembrshipDto = exports.CreateMembershipDto = void 0;
const import_dto_1 = require("../import/dto/import.dto");
const general_dto_1 = require("./general.dto");
class CreateMembershipDto {
}
exports.CreateMembershipDto = CreateMembershipDto;
class UpdateMembrshipDto extends CreateMembershipDto {
}
exports.UpdateMembrshipDto = UpdateMembrshipDto;
class UpdateMembershipMediaDto {
}
exports.UpdateMembershipMediaDto = UpdateMembershipMediaDto;
class FindMembershipByIdDto {
}
exports.FindMembershipByIdDto = FindMembershipByIdDto;
class FindMembershipsByOrganizationIdDto {
}
exports.FindMembershipsByOrganizationIdDto = FindMembershipsByOrganizationIdDto;
class FindMembershipByFiltersDto extends general_dto_1.PaginationQuery {
}
exports.FindMembershipByFiltersDto = FindMembershipByFiltersDto;
class FindMembershipsByUserIdDto {
}
exports.FindMembershipsByUserIdDto = FindMembershipsByUserIdDto;
class SetMembersStartDateByOrganization extends FindMembershipsByOrganizationIdDto {
}
exports.SetMembersStartDateByOrganization = SetMembersStartDateByOrganization;
class MembershipIdsDto {
}
exports.MembershipIdsDto = MembershipIdsDto;
class MemberIdDto {
}
exports.MemberIdDto = MemberIdDto;
class FindMembersOptionsDto extends general_dto_1.PaginationQuery {
}
exports.FindMembersOptionsDto = FindMembersOptionsDto;
class CancelMembershipDto {
}
exports.CancelMembershipDto = CancelMembershipDto;
class GetMembershipDataQueryDto extends general_dto_1.PaginationQuery {
}
exports.GetMembershipDataQueryDto = GetMembershipDataQueryDto;
class SimpleMembershipDto extends general_dto_1.IdAndNameDto {
}
exports.SimpleMembershipDto = SimpleMembershipDto;
class DateAndUserIdsDto {
}
exports.DateAndUserIdsDto = DateAndUserIdsDto;
class MembershipImportResponseDto extends import_dto_1.ImportResponseDto {
}
exports.MembershipImportResponseDto = MembershipImportResponseDto;
class MembershipMemberDto {
}
exports.MembershipMemberDto = MembershipMemberDto;
class MembershipMemberImportResponseDto extends import_dto_1.ImportResponseDto {
}
exports.MembershipMemberImportResponseDto = MembershipMemberImportResponseDto;
class AddFamilyMemberToMembershipDto {
}
exports.AddFamilyMemberToMembershipDto = AddFamilyMemberToMembershipDto;
//# sourceMappingURL=membership.dto.js.map